import { useState } from 'react';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { PageInfoHeading } from '@/components/Header/Page/PageInfoHeading';
import { useGetAllEndpointHistories } from '@/hooks/endpoint-history.hooks';
import { useTranslation } from 'react-i18next';
import { EndpointHistoryTableView } from '../components/EndpointHistoryTableView';
import { TEndpointHistorySchema } from '@/schemas/endpoint-history/endpoint-history.schema';
import { EndpointHistoryTableHeaders } from '../components/EndpointHistoryTableHeaders';
import { EndpointHistoryTableData } from '../components/EndpointHistoryTableData';

export const EndpointHistoryListPage = () => {
  const { t } = useTranslation('endpointHistory');
  const [totalActive, setTotalActive] = useState<number>(0);

  const onGetTotalActive = (total: number) => {
    setTotalActive(total);
  };

  return (
    <>
      <PageHeader
        title={t('common:endpoints')}
        totalItems={totalActive}
        headingElement={
          <PageInfoHeading text={t('common:detailsRelatedToCurrentSection')} />
        }
      />
      <div>
        <EndpointHistoryTableView<TEndpointHistorySchema>
          t={t}
          useGetAllData={useGetAllEndpointHistories}
          onGetTotalActive={onGetTotalActive}
          tableHeaders={EndpointHistoryTableHeaders}
          tableData={EndpointHistoryTableData}
        />
      </div>
    </>
  );
};
